module.exports = __webpack_public_path__ + "static/Image-3bbf952a351e6f596345bc549d66d89c.png";